export class SchemaFieldModel {
    constructor (props) {
        const {
            key, // [String]
            label, // [String]
            description, // [String]
            type, // [String]
            subType,
            subForm, // [Object]
        } = props

        this.key = key
        this.label = label
        this.description = description
        this.type = type
        this.subType = subType || null
        this.subForm = subForm
    }
}


// WEBPACK FOOTER //
// ./src/models/schema-field.model.js